import React, { useRef, useState } from 'react';
import cx from 'classnames';
import styles from './CompanyItem.module.scss';
import { useTranslation } from 'react-i18next';
import { useIsOverflow } from '../../../../../hooks/useIsOverflow';
import Icon from '../../../../../components/Icon/Icon';

const CompanyItem = ({ id, name, existing, handleDelete, children, className }) => {
  const [titleHover, setTitleHover] = useState({});
  const nameRef = useRef(null);
  const { t } = useTranslation();
  const { isOverflow } = useIsOverflow(nameRef);

  const toggleMouseEnterTitle = id => {
    if (isOverflow) {
      setTitleHover({ id: id, isHover: true });
    }
  };

  const toggleMouseLeaveTitle = id => {
    setTitleHover({ id: id, isHover: false });
  };

  return (
    <div key={id} className={cx(styles.container, className)}>
      <div className={styles.info}>
        <span
          className={styles.name}
          onMouseEnter={() => toggleMouseEnterTitle(id)}
          onMouseLeave={() => toggleMouseLeaveTitle(id)}
          ref={nameRef}
        >
          {name}
        </span>
        <Icon src="close" className={styles.deleteIcon} onClick={() => handleDelete(id)} />
      </div>
      {children}
      {titleHover.isHover && titleHover.id === id ? (
        <div className={styles.titleTooltip}>
          <span>{name}</span>
        </div>
      ) : null}
    </div>
  );
};

export default CompanyItem;
